export default __webpack_public_path__ + "static/media/cold-water.8d1fb553.svg";